import { Component } from '@angular/core';
import { fileEndings } from '../../../../shared';
import { getNestedValue } from '../../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../basic-features/icon-v2/icon.component";
import * as i3 from "../../../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i4 from "primeng/tooltip";
/**
 * @deprecated use v3 version of this component instead
 */
function FileInfoRendererComponent_div_0_geaui_icon_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isFileIcon", true)("file", "24px_" + ctx_r0.checkFileEnding(ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey)));
  }
}
function FileInfoRendererComponent_div_0_geaui_icon_v2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 6);
  }
}
function FileInfoRendererComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FileInfoRendererComponent_div_0_geaui_icon_v2_1_Template, 1, 2, "geaui-icon-v2", 2)(2, FileInfoRendererComponent_div_0_geaui_icon_v2_2_Template, 1, 0, "geaui-icon-v2", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.checkFileEnding(ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey)) !== "folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.checkFileEnding(ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey)) === "folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("pTooltip", ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey));
  }
}
export class FileInfoRendererComponent {
  rowData;
  columnKey;
  getNestedValue = getNestedValue;
  checkFileEnding(filename) {
    const fileNameSplit = filename.split('.');
    if (fileNameSplit.length === 1) return 'folder';
    const fileEnding = fileNameSplit[fileNameSplit.length - 1];
    const endingToLower = fileEnding.toLowerCase() ?? '';
    return fileEndings.has(endingToLower) ? endingToLower : 'unknown';
  }
  static ɵfac = function FileInfoRendererComponent_Factory(t) {
    return new (t || FileInfoRendererComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FileInfoRendererComponent,
    selectors: [["geaui-file-info-renderer"]],
    decls: 1,
    vars: 1,
    consts: [["class", "cell-container", 4, "ngIf"], [1, "cell-container"], ["color", "white", 3, "isFileIcon", "file", 4, "ngIf"], ["color", "black", "file", "16px_folder", 4, "ngIf"], ["geauiTooltipOnEllipsisV2", "", 1, "file-name", 3, "pTooltip"], ["color", "white", 3, "isFileIcon", "file"], ["color", "black", "file", "16px_folder"]],
    template: function FileInfoRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, FileInfoRendererComponent_div_0_Template, 5, 4, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rowData);
      }
    },
    dependencies: [i1.NgIf, i2.IconComponent, i3.TooltipOnEllipsisV2Directive, i4.Tooltip],
    styles: [".cell-container[_ngcontent-%COMP%]{display:flex;align-items:center;overflow:hidden}.cell-container[_ngcontent-%COMP%]   .file-name[_ngcontent-%COMP%]{margin-left:8px;overflow:hidden;text-overflow:ellipsis}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileInfoRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-file-info-renderer',
      template: "<div class=\"cell-container\" *ngIf=\"rowData\">\n  <geaui-icon-v2\n    *ngIf=\"checkFileEnding(getNestedValue(rowData, columnKey)) !== 'folder'\"\n    [isFileIcon]=\"true\"\n    [file]=\"'24px_' + checkFileEnding(getNestedValue(rowData, columnKey))\"\n    color=\"white\"></geaui-icon-v2>\n  <geaui-icon-v2\n    *ngIf=\"checkFileEnding(getNestedValue(rowData, columnKey)) === 'folder'\"\n    color=\"black\"\n    file=\"16px_folder\"></geaui-icon-v2>\n  <span class=\"file-name\" [pTooltip]=\"getNestedValue(rowData, columnKey)\" geauiTooltipOnEllipsisV2>{{\n    getNestedValue(rowData, columnKey)\n  }}</span>\n</div>\n",
      styles: [".cell-container{display:flex;align-items:center;overflow:hidden}.cell-container .file-name{margin-left:8px;overflow:hidden;text-overflow:ellipsis}\n"]
    }]
  }], null, null);
})();
